module.exports = __webpack_public_path__ + "img/32c0db9efc417e83160b388ce42e11ac.png";